module.exports = __webpack_public_path__ + "static/media/icnPrecaucionDoc.48187cff.svg";